@if (projectData) {
  <div class="et-project-info"
       [ngClass]="{ 'et-available-project': !isReadonly && !projectData.project.authorPeriodExpired && !projectData.project.uploadLimitAchieved,
                  'et-selected-project': selected }"
       (click)="selectProject()">
    <p-card>
      <div class="flex align-items-center ml-5">
        @if (projectData.project.hasCover) {
          <img class="w-1"
               [src]="projectData.coverSource$ | async">
        }
        <div class="flex flex-column justify-content-center ml-6 w-10">
          <span class="title4Font mb-2">{{projectData.project.name}}</span>
          @if (projectData.project.shortDescription) {
            <span class="body2Font"
                  [innerHTML]="projectData.project.shortDescription | safeMessage:'html'"></span>
          }
          @if (projectData.project.authorPeriodExpired  && !isReadonly) {
            <p-message severity="info"
                       class="warning-message subtitle3Font"
                       text="Application period is closed."
                       i18n-text>
            </p-message>
          } @else {
            @if (projectData.project.uploadLimitAchieved  && !isReadonly) {
              <p-message severity="info"
                         text="You can only upload {{projectData.project.uploadLimit}} paper(s).
            If you need to upload a new version of your paper, then please go to the My Papers page, click the 'Edit paper'
            button and reupload your new word and pdf over the old version. You can also request uploading the additional paper.
            Thank you."
                         class="warning-message subtitle3Font"
                         i18n-text>
              </p-message>
            }
          }
        </div>
      </div>
    </p-card>
  </div>
}